import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table-card layout-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              type: "button",
              class: "sort-button",
              "data-test": "sort-tech",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSort('tech')))
            }, " Tech ")
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              type: "button",
              class: "sort-button",
              "data-test": "sort-experience",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSort('experience')))
            }, " Experience ")
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("th", null, "Notes", -1))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedTech, (tech) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: tech.name
          }, [
            _createElementVNode("td", null, _toDisplayString(tech.name), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.yearsExperience(tech.startYear, tech.endYear)), 1),
            _createElementVNode("td", null, _toDisplayString(tech.notes), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}